<template>
    <div class="mobile-apps">
        <a
            v-if="dictionary.android.link !== 'footer.android.link'"
            class="mobile-app__get-app google-play android-only"
            :href="androidUrl || dictionary.android.link"
            :key="androidUrl || dictionary.android.link"
            :title="dictionary.android.alt"
            target="_blank"
        >
            <img
                src="/nuxt-assets/design2025/footer/mobileapp/googleplay.svg"
                :alt="dictionary.android.alt"
                loading="lazy"
            />
        </a>
        <a
            v-if="dictionary.ios.link !== 'footer.ios.link'"
            class="mobile-app__get-app app-store"
            :href="iosUrl || dictionary.ios.link"
            :key="iosUrl || dictionary.ios.link"
            :title="dictionary.ios.alt"
            target="_blank"
        >
            <img src="/nuxt-assets/design2025/footer/mobileapp/appstore.svg" :alt="dictionary.ios.alt" loading="lazy" />
        </a>
    </div>
</template>

<script>

export default {
    props: {
        dictionary: {
            type: Object,
            required: true,
        },
        androidUrl: {
            type: String,
            default: '',
        },
        iosUrl: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss">
.mobile-apps {
    margin: 0;
    display: flex;
    flex-direction: row;
    gap: 15px;

    @media (min-width: 768px) {
        flex-direction: column;
        margin: 0 0 30px;
    }
}

.mobile-app__get-app {
    img {
        height: 40px;
    }
}

.android-only,
.desktop-only,
.ios-only {
    display: block !important;
}

body.isDesktop .desktop-only,
body.isAndroid .android-only,
body.isIos .ios-only {
    display: block !important;
}
</style>
